var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TactonElementState } from "./types";
import { positiveInfinity, negativeInfinity } from "./constants";
import { getImageUrl } from "./common-api";
import { Unit } from "utility/number";
import { NumberType, ChoiceType, } from "api/types";
var unitMap = {
    C: Unit.C,
    "-kPa": Unit.KPA,
    kg: Unit.KG,
    L: Unit.L,
    "m/s2": Unit.M_S2,
    N: Unit.N,
    MPa: Unit.MPA,
    s: Unit.S,
    "parts/min": Unit.PPM,
};
var parseMax = function (field) {
    return field.properties.max_value && field.properties.max_value !== positiveInfinity
        ? Number(field.properties.max_value)
        : undefined;
};
var parseMin = function (field) {
    return field.properties.min_value && field.properties.min_value !== negativeInfinity
        ? Number(field.properties.min_value)
        : undefined;
};
export var getParameterAttributes = function (tactonField, groupName, ticket) {
    var props = tactonField.properties;
    var description = {};
    if (props.tc_field_view_text)
        description.long = props.tc_field_view_text;
    if (props.tc_info_text)
        description.short = props.tc_info_text;
    if (props.tc_field_view_picture)
        description.imageSource = getImageUrl(props.tc_field_view_picture, ticket);
    if (props.field_view_layout)
        description.layout = props.field_view_layout;
    if (props.field_view_picture_scale)
        description.imageScale = Number(props.field_view_picture_scale);
    if (props.field_view_max_size_pixels)
        description.maxSizePixels = Number(props.field_view_max_size_pixels);
    return __assign(__assign(__assign(__assign(__assign({ isLocked: tactonField.committed || tactonField.alwaysCommitted, groupId: groupName, id: tactonField.name, label: tactonField.description || tactonField.name }, (props.tc_field_view_picture && {
        imageSource: getImageUrl(props.tc_field_view_picture, ticket),
    })), (props.tc_field_view_picture_alt && {
        imageSourceAlt: getImageUrl(props.tc_field_view_picture_alt, ticket),
    })), (props.unit && { unit: unitMap[props.unit] || undefined })), { value: tactonField.value, hiddenInWizard: props.wizard_hidden === "yes", lockDisabled: tactonField.alwaysCommitted, readonly: props.guitype === "readonly", committed: tactonField.committed, alwaysCommitted: tactonField.alwaysCommitted, ovmDefaultValue: props.ovm_default_value }), (Object.keys(description).length > 0 && { description: description }));
};
export var getParameter = function (tactonField, groupName, ticket) {
    var _a, _b;
    var attributes = getParameterAttributes(tactonField, groupName, ticket);
    var domain = tactonField.domain.name;
    var props = tactonField.properties;
    if (domain === "float" || domain === "int") {
        return __assign(__assign({}, attributes), { type: domain === "float" ? NumberType.FLOAT : NumberType.INT, max: parseMax(tactonField), min: parseMin(tactonField) });
    }
    if (domain === "application_class" || props.piab_gui === "image") {
        var options_1 = tactonField.domain.elements
            .filter(function (el) { return el.state !== TactonElementState.RED; })
            .map(function (el) {
            var _a, _b;
            return (__assign(__assign({ label: el.description || el.name, value: el.name, selected: el.selected }, (((_a = el.properties) === null || _a === void 0 ? void 0 : _a.tc_field_view_picture) && {
                imageSource: getImageUrl(el.properties.tc_field_view_picture, ticket),
            })), (((_b = el.properties) === null || _b === void 0 ? void 0 : _b.tc_field_view_picture_alt) && {
                imageSourceAlt: getImageUrl(el.properties.tc_field_view_picture_alt, ticket),
            })));
        });
        return __assign(__assign({}, attributes), { type: ChoiceType.IMAGE_SELECT, options: options_1 });
    }
    if (props.piab_gui === "slider") {
        return __assign(__assign({}, attributes), { type: ChoiceType.SLIDER, sliderMin: props.slider_min ? Number(props.slider_min) : 200, sliderMax: props.slider_max ? Number(props.slider_max) : 200, sliderMinLabel: (_a = props.slider_min_header) !== null && _a !== void 0 ? _a : "min", sliderMaxLabel: (_b = props.slider_max_header) !== null && _b !== void 0 ? _b : "max" });
    }
    var options = tactonField.domain.elements
        .filter(function (el) { return el.state !== TactonElementState.RED; })
        .map(function (el) {
        var _a;
        return (__assign({ label: el.description || el.name, value: el.name, hasConflict: el.state === TactonElementState.ORANGE }, (((_a = el.properties) === null || _a === void 0 ? void 0 : _a.tc_field_view_picture) && {
            imageSource: getImageUrl(el.properties.tc_field_view_picture, ticket),
        })));
    });
    return __assign(__assign({}, attributes), { type: ChoiceType.DROPDOWN, options: options });
};
